import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import Logout from '../widget/Logout';

const TopBar = ({ active }) => {
	const { user } = useContext(UserContext);
	const navigate = useNavigate();

	const onAsideToggle = (event) => {
		event.currentTarget.classList.toggle('is-active');
		document.documentElement.classList.toggle('has-aside-mobile-expanded');
	};

	const onNavBarMenuToggle = (event) => {
		event.currentTarget.classList.toggle('is-active');
		document.getElementById('navbar-menu').classList.toggle('is-active');
	};

	const { t } = useTranslation();

	return (
		<div className={`navbar ${active ? 'is-active' : ''}`}>
			<span>{t('illegal_waste_dumps')}</span>
			<Logout />
		</div>
	);
};

export default TopBar;
